import { createIntl, createIntlCache } from "react-intl";
import fa_message from "./locales/fa.json";

const cache = createIntlCache();
const locale = "EN";
const intl = createIntl({ messages: fa_message, locale }, cache);

// Translate Function
const __i18n = (str, values={}) => {
  return intl.formatMessage(
    {
      id: str,
      defaultMessage: str,
    },
    values
  );
};

export default __i18n;